<template lang="html">
<div>
  <div id="vizsgalist">

    <v-container fluid>
    <v-radio-group v-model="picked" row v-if="user_mail != 'vizsga@csigaver.hu'">
      <v-radio label="Létrehozott" color="#FF9800" value="Uploaded"></v-radio>
      <v-radio label="Leadott" color="#FF9800" value="Finalized" ></v-radio>
      <v-radio label="Törölt" color="#FF9800" value="Deleted"></v-radio>
    </v-radio-group>
    <v-row class="justify-center">
        <v-col cols="12" md="3" class="mt-2">
            <v-btn @click="exam_reg_dialog = true, getOktatok()">
                      Időpont foglalás
                 <v-icon right dark>event_available</v-icon>
                </v-btn>
              </v-col>
          <v-col cols="12" md="3" class="mt-2">
            <v-btn @click="exam_search_dialog = true">
                      Időpont keresés
                 <v-icon right dark>search</v-icon>
                </v-btn>
              </v-col>
          </v-row>
  </v-container>

<v-container data-app>
<v-card v-if="user_mail != 'vizsga@csigaver.hu'">
  <v-card-title>
      Vizsgák
</v-card-title>
<v-container>
<v-text-field
  v-model="search"
  append-icon="search"
  label="Keresés"
  outlined
  color="#FF9800"
  clearable
></v-text-field>
</v-container>
<v-data-table
v-if="exams"
:headers="headers"
:items="exams"
:search="search"
:mobile-breakpoint='NaN'
sort-by="exam_date"
sort-desc
>
<template v-slot:body="{ items }">
<tbody>
<tr :style="!item.is_preregistrabled && item.exam_id ? {'background': '#FFF3E0'} : ''" class="clickable-row" v-for="(item, index) in items" @click="fetchExamsDetails(item.exam_id, item.id)">
  <td style='min-width: 100px'>{{ index + 1 }}</td>
  <td style='min-width: 150px'>{{ item.nkh_gui_id }}</td>
  <td style='min-width: 120px'>{{ item.exam_date }}</td>
  <td style='min-width: 100px'>{{ item.exam_time }}</td>
  <td style='min-width: 300px'>{{ item.location_name }}</td>
  <td style='min-width: 100px'>{{ item.count }}</td>
  <td style='min-width: 100px'>{{ item.sms }}</td>
</tr>
</tbody>
</template>
</v-data-table>
</v-card>
</v-container>

  </div>
  <v-snackbar v-model="deleteexam_snackbar" bottom>
    {{delete_result}}
    <v-btn
    color="pink"
    text
    @click="deleteexam_snackbar = false"
    >
    Bezár
    </v-btn>
  </v-snackbar>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="user_mail != 'vizsga@csigaver.hu'"
        v-on="on"
        @click="pregStudents(), prereg_dialog = true"
        style="top: 80px;"
        fixed
        fab
        top
        right
        color="white"
      >
      <v-icon>assignment</v-icon>
      </v-btn>
    </template>
    <span>Előjegyzés lista</span>
  </v-tooltip>

      <v-dialog v-model="exam_search_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="grey">
        <v-toolbar-title>Vizsgaidőpontok</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="exam_search_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
          <v-container>
              <v-card>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="nev_search"
                        label="Tanuló név"
                        hide-details
                        outlined
                        @keyup.enter="searchVizsgaidopont()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="studId_search"
                        label="Tanuló azonosító"
                        hide-details
                        outlined
                        @keyup.enter="searchVizsgaidopont()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-2">
                        <v-btn @click="searchVizsgaidopont()">
                             Keresés
                         <v-icon right dark>search</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="search_exam_picked == 'Gyakorlat'">
                    <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="gyak_vizsgahely_search"
                            :items="gyak_vizsgahely"
                            item-text="text"
                            item-value="value"
                            label="Vizsgahely"
                            outlined
                          ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="oktato_search"
                        :items="csiga_oktatok"
                        item-text="name"
                        return-object
                        label="Oktató választása"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-2">
                        <v-btn @click="exam_search_students = [], oktato_search = '', gyak_vizsgahely_search = ''" color="red" outlined>
                             szűrők Törlése
                      </v-btn>
                    </v-col>
                  </v-row>
                    <v-radio-group v-model="search_exam_picked" row>
                        <v-radio label="Elmélet" color="#FF9800" value="Elmelet"></v-radio>
                        <v-radio label="Gyakorlat" color="#FF9800" value="Gyakorlat" ></v-radio>
                     </v-radio-group>
                  <v-text-field
                    v-model="exam_dates_filter"
                    append-icon="search"
                    label="Eredmény szűrése"
                    outlined
                    color="#FF9800"
                    clearable
                  ></v-text-field>
                <v-data-table
                  v-model="students_to_mail"
                  :headers="exam_search_students_header"
                  :items="exam_search_students"
                  item-key="VizsgajegyzokonyvSorCsoportId"
                  show-select
                  :loading="exam_search_table_loader"
                  loading-text="Vizsgák betöltése folyamatban ..."
                  :search="exam_dates_filter"
                ></v-data-table>
                </v-container>
              </v-card>

              <br>

              <v-card>
              <v-container>
              <v-card-title>
                  Kiválasztott tanulók
                  <v-spacer></v-spacer>
              </v-card-title>
              <v-container>
  
                <v-data-table
                  v-model="students_to_mail"
                  :headers="exam_search_students_header"
                  :items="students_to_mail"
                  item-key="VizsgajegyzokonyvSorCsoportId"
                  show-select
                ></v-data-table>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                  <v-textarea
                    v-if="students_to_mail != ''"
                    v-model="message_text"
                    outlined
                    name="input-7-4"
                    label="Kiegészítő szöveg"
                    auto-grow
                  ></v-textarea>
                </v-col>
                      <v-col cols="12" md="3" class="mt-0" v-if="students_to_mail != ''">
                        <v-btn :disabled="mail_loader" :loading="mail_loader" @click="sendVizsgaidopont">
                             Tanulói értesítés
                         <v-icon right dark>account_circle</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-0" v-if="students_to_mail != '' && oktato_search != ''">
                        <v-btn :disabled="mail_loader" :loading="mail_loader" @click="sendVizsgaidopontToTeacher">
                             Oktatói értesítés
                         <v-icon right dark>drive_eta</v-icon>
                      </v-btn>
                    </v-col>
                </v-row>
                 <v-row>
                    <v-col cols="12" md="3" class="mt-2" v-if="students_to_mail != ''">
                        <v-btn color="red" dark :disabled="del_loader" :loading="del_loader" @click="delete_results = null, exam_del_confirm_dialog = true">
                             Időpontok törlése
                         <v-icon right dark>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                    </v-container>
                  </v-row>
                </v-container>
              </v-card>


          </v-container>
        </v-card>

      </v-dialog>

    <v-dialog v-model="exam_reg_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="grey">
        <v-toolbar-title>Vizsgára jelentkezés</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="exam_reg_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
        
          <v-container>
            <v-tabs grow v-model="exam_tab" background-color="grey lighten-3" icons-and-text>
              <v-tab v-show="user_mail != 'vizsga@csigaver.hu'">Elmélet<v-icon>school</v-icon></v-tab>
              <v-tab>Gyakorlat<v-icon>directions_car</v-icon></v-tab>
            </v-tabs>
            <v-tabs-items v-model="exam_tab">
              <v-tab-item>
                <v-row>
                  <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="selected_exam_type_code"
                    :items="exam_type_codes"
                    item-text="name"
                    item-value="exam_code"
                    label="Vizsga típusa"
                    outlined
                  ></v-autocomplete>
                </v-col>
                </v-row>
                <v-tabs grow v-model="exam_elmelet_tab">
                  <v-tab>Tanulók</v-tab>
                  <v-tab :disabled="!valid_payment_elm || !exam_type_valid_elm || selected_students_elm == ''">Vizsgaidőpontok</v-tab>
                </v-tabs>
                <v-tabs-items v-model="exam_elmelet_tab">
                  <v-tab-item>
                    <br>
                  <v-text-field
                    v-model="elm_student_search"
                    append-icon="mdi-magnify"
                    label="Tanuló keresése"
                    single-line
                    hide-details
                    @keyup.enter="getTanulokElm()"
                    outlined
                  ></v-text-field>
                  <v-data-table
                    v-model="selected_students_elm"
                    :headers="elm_exam_students"
                    :items="elm_students"
                    item-key="course_data_id"
                    show-select
                    :loading="students_table_loader"
                    loading-text="Tanulók betöltése folyamatban ..."
                    :search="elm_student_search"
                  >
                  <template v-slot:item.name="{ item }">
                    <a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.name }}</a>
                  </template>
                    <template v-slot:header.data-table-select></template>
                    <template v-slot:item.data-table-select="{ item, isSelected, select }">
                      <v-simple-checkbox
                        :value="isSelected"
                        :readonly="!item.exam_type || item.exam_type == '' || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                        :disabled="!item.exam_type || item.exam_type == '' || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                        @input="select($event)"
                      ></v-simple-checkbox>
                    </template>
                  <template v-slot:item.exam_type="{ item }">
                      <v-combobox
                        small-chips
                        multiple
                        dense
                        chips
                        :loading="item.getExamTypeLoader"
                        v-model="item.exam_type"
                        item-text="Megnevezes"
                        return-object
                        :items="elm_exam_types"
                        @click="getElmExamType(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                        @change="elmStudExamValidator(item)"
                      >
                      </v-combobox>
                    </template>
                    <template v-slot:item.exam_invoice="{ item }">
                      <v-combobox
                        v-model="item.exam_invoice"
                        :items="exam_fees"
                        item-text="amount"
                        item-value="payment_id"
                        dense
                        multiple
                        small-chips
                        chips
                        @click="getPayments(item.contract_id, item.customer_id)"
                        @change="elmStudPaymentValidator(item)"
                      >
                      <template v-slot:item="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                          <div class="body-2">{{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})</div>
                      </template>
                      </v-combobox>
                    </template>
                  </v-data-table>
                    <v-overlay v-model="getElmExamTypeLoader">
                        <v-progress-circular
                          :size="100"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                  </v-overlay>
                  <v-dialog
                    v-model="elm_exam_select_error_dialog"
                    width="600"
                  >
                      <v-card>
                        <v-toolbar
                          color="red"
                          dark
                        >Hiba történt</v-toolbar>
                        <v-card-text>
                          <div class="text-h5 pt-4">A tanulóhoz nem rendelhető vizsga a KAV rendszerében!</div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn
                            text
                            @click="elm_exam_select_error_dialog = false"
                          >bezár</v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="text-center" v-if="selected_students_elm == ''">
                      <br>
                      Nincsenek kiválasztva tanulók!
                    </div>

                <v-dialog
                    persistent
                    v-model="elm_exam_result_dialog"
                    width="600"
                  >
                      <v-card>
                        <v-toolbar :color="elm_success_color" dark>
                          <v-toolbar-title>{{elm_save_title}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="elm_exam_result_dialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-container>
                          <div v-if="elm_save_success == 'true'">
                          Vizsga helyszíne: {{elm_save_vizsgahely}}
                          <v-data-table
                            :headers="elm_save_students_header"
                            :items="elm_save_students"
                          ></v-data-table>
                          </div>
                          <div v-html="elm_save_error"></div>
                        </v-container>
                        <v-card-actions class="justify-end" v-if="elm_save_success == 'true'">
                              <v-checkbox
                                v-model="tanulo_checkbox"
                                label="Tanuló"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                            <v-btn outlined :disabled="!tanulo_checkbox || sendAfterSave_loader" :loading="sendAfterSave_loader" @click="sendVizsgaidopontAfterSave()">
                              Értesítés
                                  <v-icon right dark>mail</v-icon>
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>

                  <v-dialog
                    persistent
                    v-model="elm_deadline_check_dialog"
                    width="600"
                  >
                      <v-card>
                        <v-toolbar color="red" dark>
                          <v-toolbar-title>Figyelem!</v-toolbar-title>
                        </v-toolbar>
                        <v-container>
                          A kiválasztott vizsga módosítási határideje lejárt (8 nap)!<br>
                          Amennyiben mégis rögzíti, a tanulónak nem lesz lemondási lehetősége, a vizsgadíj véglegesen felhasználásra kerül!
                        </v-container>
                        <v-card-actions>
                              <v-spacer></v-spacer>
                            <v-btn outlined color="red" @click="elm_deadline_check_dialog = false">
                              Mégsem
                            </v-btn>
                            <v-btn outlined color="green" @click="addElmVizsga(), elm_deadline_check_dialog = false">
                              Rögzít
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>

                  <div class="text-center" v-if="selected_students_elm != ''">
                        <v-row>
                            <v-col cols="12" md="3">
                              <v-menu v-model="elm_start_menu" :close-on-content-click="false" transition="scale-transition" offset-y  min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="elm_start_date" label="Kezdő dátum" append-icon="event" readonly v-on="on" outlined>
                                  </v-text-field>
                                </template>
                                <v-date-picker v-model="elm_start_date" no-title scrollable first-day-of-week=1>
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" @click="elm_start_menu = false">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="3">
                              <v-menu ref="gyak_end_menu" v-model="elm_end_menu" :close-on-content-click="false" transition="scale-transition" offset-y  min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="elm_end_date" label="Befejező dátum" append-icon="event" readonly v-on="on" outlined>
                                  </v-text-field>
                                </template>
                                <v-date-picker v-model="elm_end_date" no-title scrollable first-day-of-week=1>
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" @click="elm_end_menu = false">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="3">
                              <v-select
                                outlined
                                v-model="elm_exam_place"
                                :items="elm_exam_places"
                                item-text="text"
                                item-value="value"
                                label="Vizsga helyszíne"
                                multiple
                              ></v-select>
                            </v-col>
                          <v-col cols="12" md="2" class="mt-2">
                            <v-btn :disabled="!elm_start_date || !elm_end_date" @click="getElmVizsgaIdopontok()">
                              Keresés
                              <v-icon right dark>search</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>

                        <v-data-table
                            v-model="selected_elm_exam"
                            :headers="elm_exams"
                            :items="elm_idopontok"
                            item-key="Id"
                            show-select
                            single-select
                            :loading="elm_exam_table_loader"
                            loading-text="Vizsgák betöltése folyamatban ..."
                          >
                          </v-data-table>
                          <v-data-table
                            v-model="selected_students_elm"
                            :headers="elm_exam_students"
                            :items="selected_students_elm"
                            item-key="course_data_id"
                            show-select
                          >
                          <template v-slot:item.name="{ item }">
                            <a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.name }}</a>
                          </template>
                          <template v-slot:header.data-table-select></template>
                            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                              <v-simple-checkbox
                                :value="isSelected"
                                :readonly="!item.exam_type || item.exam_type == '' || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                                :disabled="!item.exam_type || item.exam_type == '' || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                                @input="select($event)"
                              ></v-simple-checkbox>
                            </template>
                          <template v-slot:item.exam_type="{ item }">
                            <v-combobox
                              small-chips
                              multiple
                              dense
                              chips
                              :loading="item.getExamTypeLoader"
                              v-model="item.exam_type"
                              item-text="Megnevezes"
                              return-object
                              :items="elm_exam_types"
                              @click="getElmExamType(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                              @change="elmStudExamValidator(item)"
                            >
                            </v-combobox>
                          </template>
                          <template v-slot:item.exam_invoice="{ item }">
                            <v-combobox
                              v-model="item.exam_invoice"
                              :items="exam_fees"
                              item-text="amount"
                              item-value="payment_id"
                              dense
                              multiple
                              small-chips
                              chips
                              @click="getPayments(item.contract_id, item.customer_id)"
                              @change="elmStudPaymentValidator(item)"
                            >
                            <template v-slot:item="data">
                              <!-- HTML that describe how select should render items when the select is open -->
                              <div class="body-2">{{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})</div>
                            </template>
                            </v-combobox>
                          </template>
                          </v-data-table>
                          <v-row>
                          <v-col cols="12" md="2" class="mt-2">
                            <v-btn :loading="elm_vizsga_rogzit_loader" :disabled="!selected_elm_exam || !elm_idopontok || !valid_payment_elm || !exam_type_valid_elm" v-if="selected_elm_exam != '' || elm_vizsga_rogzit_loader" @click="elmExamDeadlineCheck()">
                              Rögzítés
                              <v-icon right dark>save</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                  </div>

                  </v-tab-item>
                </v-tabs-items>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="selected_oktato"
                    :items="csiga_oktatok"
                    item-text="name"
                    item-value="teacher_id"
                    label="Oktató választása"
                    outlined
                  ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-container>
                <v-tabs grow v-model="exam_students_tab" v-if="selected_oktato">
                  <v-tab>Tanulók</v-tab>
                  <v-tab :disabled="!valid_payment || !exam_type_valid || !valid_frsz || selected_students == ''">Vizsgaidőpontok</v-tab>
                </v-tabs>
                <v-tabs-items v-model="exam_students_tab">
                  <v-tab-item>
                    <br>
                    <v-expansion-panels>
                      <v-expansion-panel
                      >
                        <v-expansion-panel-header>
                          Motoros vizsgajelentés vizsgázó mellé
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="karton_nev_search"
                                label="Tanuló név"
                                hide-details
                                outlined
                                @keyup.enter="searchKarton()"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="karton_studId_search"
                                label="Tanuló azonosító"
                                hide-details
                                outlined
                                @keyup.enter="searchKarton()"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-2">
                                <v-btn :disabled="karton_loader" :loading="karton_loader" @click="searchKarton()">
                                    Karton Keresés
                                <v-icon right dark>search</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="karton_azonosito"
                                label="Karton azonosító"
                                hide-details
                                outlined
                                hint="Kereshető vagy szabadon megadható"
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-2">
                                <v-btn :disabled="!studentAmountCheck || motorosCheckLoader" :loading="motorosCheckLoader" outlined color="green" @click="checkMotorosMelle()">
                                    Vizsgajelentés
                                <v-icon right dark>event_available</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <div class="red--text" v-if="selected_students != '' && !studentAmountCheck">Egyszerre csak egy tanuló mellé rendelhető másik vizsgázó!</div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <v-dialog
                    persistent
                    v-model="karton_check_dialog"
                    width="700"
                  >
                      <v-card>
                        <v-toolbar color="blue" dark>
                          <v-toolbar-title>Időponttal rendelkező tanuló kiválasztása</v-toolbar-title>
                        </v-toolbar>
                        <v-container>
                          <v-data-table
                            :headers="studentKartonIds_header"
                            :items="studentKartonIds"
                            item-key="Id"
                            @click:row="getKartonId($event)"
                          >
                          </v-data-table>
                        </v-container>
                        <v-card-actions>
                              <v-spacer></v-spacer>
                            <v-btn outlined color="red" @click="karton_check_dialog = false">
                              bezár
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>
                  <v-dialog
                    persistent
                    v-model="motorosMelle_check_dialog"
                    width="700"
                  >
                      <v-card>
                        <v-toolbar color="blue" dark>
                          <v-toolbar-title>Keresés eredménye</v-toolbar-title>
                        </v-toolbar>
                        <v-container>
                          <div v-if="motorosMelle_check_error">
                            {{motorosMelle_check_error}}
                          </div>
                          <div v-if="!motorosMelle_check_error">
                            Időpont: {{motorosMelle_check_idopont}}<br>
                            Helyszín: {{motorosMelle_check_helyszin}}<br>
                            Kategória: {{motorosMelle_check_kategoria}}<br>
                            Vizsgatárgy: {{motorosMelle_check_targy}}<br>
                          </div>
                        </v-container>
                        <v-card-actions>
                            <v-btn outlined color="red" @click="motorosMelle_check_dialog = false">
                              bezár
                            </v-btn>
                              <v-spacer></v-spacer>
                            <v-btn v-if="!motorosMelle_check_error" outlined color="green" @click="addMotorosMelle()" :disabled="motorosSaveLoader" :loading="motorosSaveLoader">
                              rögzítés
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>
                  <v-dialog
                    persistent
                    v-model="motorosMelle_result_dialog"
                    width="600"
                    min-height="200"
                  >
                      <v-card>
                        <v-toolbar :color="gyak_success_color" dark>
                          <v-toolbar-title>{{gyak_save_title}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="motorosMelle_result_dialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-container>
                          <div v-if="gyak_save_success == 'true'">
                          Vizsga helyszíne: {{gyak_save_vizsgahely}}
                          <v-data-table
                            :headers="gyak_save_students_header"
                            :items="gyak_save_students"
                          ></v-data-table>
                          </div>
                          <div v-html="gyak_save_error"></div>
                        </v-container>
                        <v-card-actions class="justify-end" v-if="gyak_save_success == 'true'">
                              <v-checkbox
                                v-model="oktato_checkbox"
                                label="Oktató"
                              ></v-checkbox>
                              <v-checkbox
                                v-model="tanulo_checkbox"
                                label="Tanuló"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                            <v-btn outlined :disabled="!oktato_checkbox && !tanulo_checkbox || sendAfterSave_loader" :loading="sendAfterSave_loader" @click="sendVizsgaidopontAfterSave()">
                              Értesítés
                                  <v-icon right dark>mail</v-icon>
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>
                    <br>
                  <v-text-field
                    v-model="gyak_student_search"
                    append-icon="mdi-magnify"
                    label="Tanuló keresése"
                    single-line
                    hide-details
                    outlined
                  ></v-text-field>
                  <v-data-table
                    v-model="selected_students"
                    :headers="gyak_exam_students"
                    :items="students"
                    item-key="course_data_id"
                    show-select
                    :loading="students_table_loader"
                    loading-text="Tanulók betöltése folyamatban ..."
                    :search="gyak_student_search"
                  >
                  <template v-slot:item.name="{ item }">
                    <a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.name }}</a>
                  </template>
                  <template v-slot:header.data-table-select></template>
                     <template v-slot:item.data-table-select="{ item, isSelected, select }">
                      <v-simple-checkbox
                        :value="isSelected"
                        :readonly="!item.exam_type || item.exam_type == '' || ((!item.frsz || item.frsz == '') && item.soap_course_type_code != 'AM') || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                        :disabled="!item.exam_type || item.exam_type == '' || ((!item.frsz || item.frsz == '') && item.soap_course_type_code != 'AM') || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                        @input="select($event), gyakStudFrszValidator(item)"
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:item.exam_type="{ item }">
                      <v-combobox
                        small-chips
                        multiple
                        dense
                        chips
                        :loading="item.getExamTypeLoader"
                        v-model="item.exam_type"
                        item-text="Megnevezes"
                        return-object
                        :items="exam_types"
                        @click="getExamType(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                        @change="gyakStudExamValidator(item)"
                      >
                      <template v-slot:item="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        <div class="body-2">{{ data.item.Megnevezes }}</div><div v-show="data.item.Datum" class="body-2"> ({{data.item.DatumString}})</div>
                      </template>
                      </v-combobox>
                    </template>
                    <template v-slot:item.frsz="{ item }">
                      <v-combobox
                        dense
                        small-chips
                        chips
                        v-model="item.frsz"
                        item-text="Megnevezes"
                        item-value="Megnevezes"
                        :items="rendszamok"
                        @click="getRendszam(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                        @change="gyakStudFrszValidator(item)"
                      ></v-combobox>
                    </template>
                    <template v-slot:item.exam_invoice="{ item }">
                      <v-combobox
                        v-model="item.exam_invoice"
                        :items="exam_fees"
                        item-text="amount"
                        item-value="payment_id"
                        dense
                        multiple
                        small-chips
                        chips
                        @click="getPayments(item.contract_id, item.customer_id)"
                        @change="gyakStudPaymentValidator(item)"
                      >
                      <template v-slot:item="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        <div class="body-2">{{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})</div>
                      </template>
                      </v-combobox>
                    </template>
                  </v-data-table>
                  <v-overlay v-model="getExamTypeLoader">
                        <v-progress-circular
                          :size="100"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                  </v-overlay>
                  <v-dialog
                    v-model="exam_select_error_dialog"
                    width="600"
                  >
                      <v-card>
                        <v-toolbar
                          color="red"
                          dark
                        >Hiba történt</v-toolbar>
                        <v-card-text>
                          <div class="text-h5 pt-4">A tanulóhoz nem rendelhető vizsga a KAV rendszerében!</div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn
                            text
                            @click="exam_select_error_dialog = false"
                          >bezár</v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>

                  </v-tab-item>
                  <v-tab-item>
                    <div class="text-center" v-if="selected_students == ''">
                      <br>
                      Nincsenek kiválasztva tanulók!
                    </div>

                    <v-dialog
                    persistent
                    v-model="gyak_exam_result_dialog"
                    width="600"
                    min-height="200"
                  >
                      <v-card>
                        <v-toolbar :color="gyak_success_color" dark>
                          <v-toolbar-title>{{gyak_save_title}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="gyak_exam_result_dialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-container>
                          <div v-if="gyak_save_success == 'true'">
                          Vizsga helyszíne: {{gyak_save_vizsgahely}}
                          <v-data-table
                            :headers="gyak_save_students_header"
                            :items="gyak_save_students"
                          ></v-data-table>
                          </div>
                          <div v-html="gyak_save_error"></div>
                        </v-container>
                        <v-card-actions class="justify-end" v-if="gyak_save_success == 'true'">
                              <v-checkbox
                                v-model="oktato_checkbox"
                                label="Oktató"
                              ></v-checkbox>
                              <v-checkbox
                                v-model="tanulo_checkbox"
                                label="Tanuló"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                            <v-btn outlined :disabled="!oktato_checkbox && !tanulo_checkbox || sendAfterSave_loader" :loading="sendAfterSave_loader" @click="sendVizsgaidopontAfterSave()">
                              Értesítés
                                  <v-icon right dark>mail</v-icon>
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>

                  <v-dialog
                    persistent
                    v-model="gyak_deadline_check_dialog"
                    width="600"
                  >
                      <v-card>
                        <v-toolbar color="red" dark>
                          <v-toolbar-title>Figyelem!</v-toolbar-title>
                        </v-toolbar>
                        <v-container>
                          A kiválasztott vizsga módosítási határideje lejárt (8 nap)!<br>
                          Amennyiben mégis rögzíti, a tanulónak nem lesz lemondási lehetősége, a vizsgadíj véglegesen felhasználásra kerül!
                        </v-container>
                        <v-card-actions>
                              <v-spacer></v-spacer>
                            <v-btn outlined color="red" @click="gyak_deadline_check_dialog = false">
                              Mégsem
                            </v-btn>
                            <v-btn outlined color="green" @click="addGyakVizsga(), gyak_deadline_check_dialog = false">
                              Rögzít
                            </v-btn>
                        </v-card-actions>
                      </v-card>
                  </v-dialog>

                    <div class="text-center" v-if="selected_students != ''">
                        <v-row>
                            <v-col cols="12" md="3">
                              <v-menu v-model="gyak_start_menu" :close-on-content-click="false" transition="scale-transition" offset-y  min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="gyak_start_date" label="Kezdő dátum" append-icon="event" readonly v-on="on" outlined>
                                  </v-text-field>
                                </template>
                                <v-date-picker v-model="gyak_start_date" no-title scrollable first-day-of-week=1>
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" @click="gyak_start_menu = false">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="3">
                              <v-menu ref="gyak_end_menu" v-model="gyak_end_menu" :close-on-content-click="false" transition="scale-transition" offset-y  min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="gyak_end_date" label="Befejező dátum" append-icon="event" readonly v-on="on" outlined>
                                  </v-text-field>
                                </template>
                                <v-date-picker v-model="gyak_end_date" no-title scrollable first-day-of-week=1>
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" @click="gyak_end_menu = false">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="selected_gyak_vizsgahely"
                            :items="gyak_vizsgahely"
                            item-text="text"
                            item-value="value"
                            label="Vizsgahely"
                            outlined
                          ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="2" class="mt-2">
                            <v-btn :disabled="!gyak_start_date || !gyak_end_date || !selected_gyak_vizsgahely" @click="getVizsgaIdopontok()">
                              Keresés
                              <v-icon right dark>search</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                          <v-data-table
                            v-model="selected_gyak_exam"
                            :headers="gyak_exams"
                            :items="gyak_idopontok"
                            item-key="Id"
                            show-select
                            single-select
                            :loading="gyak_exam_table_loader"
                            loading-text="Vizsgák betöltése folyamatban ..."
                          >
                          </v-data-table>

                          <v-data-table
                            v-model="selected_students"
                            :headers="gyak_exam_students"
                            :items="selected_students"
                            item-key="course_data_id"
                            show-select
                          >
                          <template v-slot:item.name="{ item }">
                            <a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.name }}</a>
                          </template>
                          <template v-slot:header.data-table-select></template>
                            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                              <v-simple-checkbox
                                :value="isSelected"
                                :readonly="!item.exam_type || item.exam_type == '' || ((!item.frsz || item.frsz == '') && item.soap_course_type_code != 'AM') || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                                :disabled="!item.exam_type || item.exam_type == '' || ((!item.frsz || item.frsz == '') && item.soap_course_type_code != 'AM') || ((!item.exam_invoice || item.exam_invoice == '') && !admin)"
                                @input="select($event)"
                              ></v-simple-checkbox>
                            </template>
                          <template v-slot:item.exam_type="{ item }">
                            <v-combobox
                              small-chips
                              multiple
                              dense
                              chips
                              :loading="item.getExamTypeLoader"
                              v-model="item.exam_type"
                              item-text="Megnevezes"
                              return-object
                              :items="elm_exam_types"
                              @click="getElmExamType(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                              @change="gyakStudExamValidator(item)"
                            >
                            </v-combobox>
                          </template>
                          <template v-slot:item.frsz="{ item }">
                            <v-combobox
                              dense
                              small-chips
                              chips
                              v-model="item.frsz"
                              item-text="Megnevezes"
                              item-value="Megnevezes"
                              :items="rendszamok"
                              @click="getRendszam(item.contract_id, item.customer_id, item.course_student_id, item.birthdate)"
                              @change="gyakStudFrszValidator(item)"
                            ></v-combobox>
                          </template>
                          <template v-slot:item.exam_invoice="{ item }">
                            <v-combobox
                              v-model="item.exam_invoice"
                              :items="exam_fees"
                              item-text="amount"
                              item-value="payment_id"
                              dense
                              multiple
                              small-chips
                              chips
                              @click="getPayments(item.contract_id, item.customer_id)"
                              @change="gyakStudPaymentValidator(item)"
                            >
                            <template v-slot:item="data">
                              <!-- HTML that describe how select should render items when the select is open -->
                             <div class="body-2">{{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})</div>
                            </template>
                            </v-combobox>
                          </template>
                          </v-data-table>

                          <v-row>
                          <v-col cols="12" md="2" class="mt-2">
                            <v-btn :loading="gyak_vizsga_rogzit_loader" :disabled="!selected_gyak_exam || gyak_vizsga_rogzit_loader || !valid_payment || !exam_type_valid || !valid_frsz" v-if="selected_gyak_exam != ''" @click="gyakExamDeadlineCheck()">
                              Rögzítés
                              <v-icon right dark>save</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                    </div>
                  </v-tab-item>
                  </v-tabs-items>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        
      </v-card>
    </v-dialog>

             <v-dialog
              v-model="exam_del_confirm_dialog"
              persistent
              max-width="600"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Vizsgaidőpontok lemondása
                </v-card-title>
                <v-card-text>
                  <div v-if="!delete_results">
                  {{confirm_message}}
                  </div>
                  <div v-if="delete_results">
                    <ul>
                      <li v-for="item in delete_results">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="!delete_results"
                    color="red"
                    text
                    @click="exam_del_confirm_dialog = false"
                  >
                    Nem
                  </v-btn>
                  <v-btn
                    v-if="!delete_results"
                    color="green"
                    text
                    @click="delExams()"
                    :loading="del_loader"
                    :disabled="del_loader"
                  >
                    Igen
                  </v-btn>
                  <v-btn
                    v-if="delete_results"
                    color="green"
                    text
                    @click="exam_del_confirm_dialog = false"
                  >
                    Bezár
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

 <template>
  <v-row justify="center">
    <v-dialog v-model="prereg_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
        <v-toolbar-title>Előjegyzett tanulók</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="prereg_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
            <v-btn rounded color="primary" @click="pregStudentsToExam">
              Előjegyzés indítása
            </v-btn>
            </v-row>
            <br>
          <v-row>
            <v-text-field
              v-model="preg_student_search"
              label="Tanuló keresése"
              outlined
              clearable
              prepend-inner-icon="search"
            ></v-text-field>
          </v-row>
            <v-data-table
            :headers="preg_students_header"
            :items="preg_students"
            item-key="eab_id"
            :mobile-breakpoint='NaN'
            :search="preg_student_search"
            >
            <template v-slot:body="{ items }">
             <tbody>
              <tr v-for="(item, index) in items">
              <td style='min-width: 100px'>{{ index + 1 }}</td>
              <td style='min-width: 150px'>{{item.full_name}}</td>
              <td style='min-width: 130px'>{{item.birthdate}}</td>
              <td style='min-width: 130px'>{{item.contract_name}}</td>
              <td style='min-width: 120px'>{{item.course_student_id}}</td>
              <td style='min-width: 140px'>{{item.creation_date}}</td>
              <td style='min-width: 160px'>{{item.place_name}}</td>
              <td>
                <v-btn @click="delPregStudent(item.eab_id)" outlined small fab color="primary">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
           </tbody>
          </template>
          </v-data-table>
          </v-container>
          <div v-html="prereg_response"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth';
import axios from 'axios'
import store from '../store'
import router from '../router'
import {
  mapFields
} from 'vuex-map-fields'

var date = new Date();
date.setDate(date.getDate() + 9);

var end_date = new Date();
end_date.setDate(end_date.getDate() + 39);

export default {
  data() {
    return {
        search: '',
        headers: [
          { text: 'Sorszám'},
          { text: 'Azonosító', value: 'nkh_gui_id'},
          { text: 'Dátum', value: 'exam_date' },
          { text: 'Időpont', value: 'exam_time' },
          { text: 'Helyszín', value: 'location_name' },
          { text: 'Létszám', value: 'count' },
          { text: 'Értesítés', value: 'sms' },
        ],
      picked: 'Uploaded',
      exams: '',
      error_text: '',
      user: '',
      delete_result: '',
      deleteexam_snackbar: false,
      prereg_dialog: false,
      preg_student_search: '',
      preg_students: [],
      preg_students_header: [
        { text: 'Sorszám'},
        { text: 'Név', value: 'full_name'},
        { text: 'Születési idő', value: 'birthdate' },
        { text: 'Kategória', value: 'contract_name' },
        { text: 'Tanuló azonosító', value: 'course_student_id' },
        { text: 'Előjegyzés ideje', value: 'creation_date' },
      ],
      gyak_exam_students: [
        { text: 'Név', value: 'name', width: 180 },
        { text: 'Születési idő', value: 'birthdate', width: 120 },
        { text: 'Kategória', value: 'soap_course_type_code' },
        { text: 'Tanuló azonosító', value: 'course_student_id' },
        { text: 'Vizsga típusa', value: 'exam_type' },
        { text: 'Rendszám', value: 'frsz' },
        { text: 'Vizsgadíj', value: 'exam_invoice' },
      ],
      gyak_exams: [
        { text: 'Kezdési idő', value: 'Idopont'},
        { text: 'Befejezési idő', value: 'VizsgaIdejeVege' },
        { text: 'Helyszín', value: 'VizsgahelyszinNev' },
        { text: 'Azonosító', value: 'Azonosito' },
        { text: 'Telítettség', value: 'TelitettsegStringValue' },
      ],
      elm_exams: [
        { text: 'Kezdési idő', value: 'Idopont'},
        { text: 'Befejezési idő', value: 'VizsgaIdejeVege' },
        { text: 'Helyszín', value: 'VizsgahelyszinNev' },
        { text: 'Telítettség', value: 'TelitettsegStringValue' },
      ],
      elm_exam_places: [],
      elm_exam_students: [
        { text: 'Név', value: 'name', width: 180 },
        { text: 'Születési idő', value: 'birthdate', width: 120 },
        { text: 'Kategória', value: 'soap_course_type_code' },
        { text: 'Tanuló azonosító', value: 'course_student_id' },
        { text: 'Vizsga típusa', value: 'exam_type' },
        { text: 'Vizsgadíj', value: 'exam_invoice' },
      ],
      elm_save_students_header: [
        { text: 'Név', value: 'TeljesNev', width: 180 },
        { text: 'Időpont', value: 'IdopontString' },
      ],
      gyak_save_students_header: [
        { text: 'Név', value: 'TeljesNev', width: 180 },
        { text: 'Időpont', value: 'IdopontString' },
      ],
      prereg_response: '',
      exam_reg_dialog: false,
      exam_tab: [],
      exam_students_tab: null,
      exam_elmelet_tab: null,
      csiga1_oktatok: [],
      csiga2_oktatok: [],
      csiga_oktatok: [],
      selected_oktato: '',
      students: [],
      selected_students: [],
      gyak_student_search: '',
      exam_types: [],
      selected_exam_type: '',
      getExamTypeLoader: false,
      getElmExamTypeLoader: false,
      exam_type_load_text: '',
      students_table_loader: false,
      frsz_load_text: '',
      rendszamok: [],
      gyak_vizsgahely: [],
      selected_gyak_vizsgahely: '',
      gyak_start_menu: false,
      gyak_start_date: date.toISOString().substr(0, 10),
      gyak_end_menu: false,
      gyak_end_date: end_date.toISOString().substr(0, 10),
      gyak_idopontok: [],
      selected_gyak_exam: [],
      gyak_exam_table_loader: false,
      exam_fees: [],
      exam_select_error_dialog: false,
      elm_exam_select_error_dialog: false,
      loading_overlay: false,
      elm_student_search: '',
      elm_students: [],
      selected_students_elm: [],
      elm_exam_types: [],
      elm_start_menu: false,
      elm_start_date: date.toISOString().substr(0, 10),
      elm_end_menu: false,
      elm_end_date: end_date.toISOString().substr(0, 10),
      selected_elm_exam: [],
      elm_idopontok: [],
      elm_exam_table_loader: false,
      elm_vizsga_rogzit_loader: false,
      elm_exam_result_dialog: false,
      elm_save_title: '',
      elm_save_students: [],
      elm_save_vizsgahely: '',
      elm_save_success: '',
      elm_save_error: '',
      gyak_exam_result_dialog: false,
      gyak_save_title: '',
      gyak_save_students: [],
      gyak_save_vizsgahely: '',
      gyak_save_success: '',
      gyak_save_error: '',
      gyak_vizsga_rogzit_loader: false,
      gyak_success_color: '',
      elm_success_color: '',
      exam_search_dialog: false,
      idopont_search: '',
      studId_search: '',
      nev_search: '',
      exam_search_students: [],
      exam_search_students_header: [
        { text: 'Név', value: 'TanuloNev', width: 180 },
        { text: 'Született', value: 'SzuletesiIdo', width: 180 },
        { text: 'Azonosító', value: 'TanuloAzonosito', width: 180 },
        { text: 'Időpont', value: 'Idopont' },
        { text: 'Hely', value: 'VizsgahelyszinMegnevezes' },
        { text: 'Tárgy', value: 'VizsgaKodok' },
      ],
      search_exam_picked: 'Elmelet',
      exam_search_table_loader: false,
      exam_dates_filter: '',
      students_to_mail: [],
      mail_loader: false,
      saved_exam_results: [],
      oktato_checkbox: false,
      tanulo_checkbox: false,
      sendAfterSave_loader: false,
      valid_frsz: false,
      valid_payment: false,
      exam_type_valid: false,
      valid_payment_elm: false,
      exam_type_valid_elm: false,
      elm_deadline_check_dialog: false,
      gyak_deadline_check_dialog: false,
      del_loader: false,
      exam_del_confirm_dialog: false,
      confirm_message: 'Biztosan lemondja a kiválasztott vizsgákat?',
      delete_results: [],
      exam_type_codes: [
        { name: 'Számítógépes', exam_code: 725},
        { name: 'GKI Esettanulmány', exam_code: 721},
      ],
      selected_exam_type_code: 725,
      karton_studId_search: '',
      karton_nev_search: '',
      karton_azonosito: '',
      karton_loader: false,
      karton_check_dialog: false,
      studentKartonIds: [],
      studentKartonIds_header: [
        { text: 'Név', value: 'TeljesNev', width: 180 },
        { text: 'Kategória', value: 'Kepzes', width: 180 },
        { text: 'Azonosító', value: 'TanuloAzonosito', width: 180 },
        { text: 'Karton azonosító', value: 'Azonosito', width: 150  },
      ],
      motorosMelle_check_dialog: false,
      motorosMelle_check_idopont: '',
      motorosMelle_check_helyszin: '',
      motorosMelle_check_kategoria: '',
      motorosMelle_check_targy: '',
      motorosMelle_check_error: '',
      motorosCheckLoader: false,
      motorosMellePost: [],
      motorosSaveLoader: false,
      motorosMelle_result_dialog: false,
      message_text: '',
      gyak_vizsgahely_search: '',
      oktato_search: '',
      kav_oktatok: [],
      elm_exam_place: [],
    }
  },
  methods: {
    getKartonId(item) {
      this.karton_azonosito = item.Azonosito;
      this.karton_nev_search = item.TeljesNev;
      this.karton_check_dialog = false;
    },
    dateAlert: function() {
      let deadline_date = new Date("2023-09-31 11:00");
      deadline_date.setDate(deadline_date.getDate() - 8);
      let today = new Date();
      if (today > deadline_date) {
        alert('A módosítási határidő lejárt!');
      }
      console.log(today);
    },
    delExams: async function() {
        this.del_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/exams_del', {
          token: this.token,
          selected_exam_to_del: this.students_to_mail
        }).then((response) => {
          this.del_loader = false
          this.delete_results = response.data['tanulok'];
          console.log(response.data);
          this.searchVizsgaidopont()
          this.students_to_mail = []
        }, (error) => {
          this.del_loader = false
          console.log(error.data);
        })
      },
      searchKarton: async function() {
        this.karton_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/karton_kereses', {
          token: this.token,
          karton_studId_search: this.karton_studId_search,
          karton_nev_search: this.karton_nev_search
        }).then((response) => {
          this.karton_loader = false
          this.studentKartonIds = response.data['Data'];
          this.karton_check_dialog = true
          console.log(response.data);
        }, (error) => {
          this.karton_loader = false
          console.log(error.data);
        })
      },
    fetchExams: async function() {
      this.exams = ''
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/vizsgak/vizsgak', {
        status: this.picked,
        token: this.token
      }).then((response) => {
        store.state.showing.preloader = false
        this.exams = response.data
        this.resp = response
        console.log(response);
      }, (error) => {
        this.error_text = error.data
      })
    },
    pregStudents: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/vizsgak/prereg_students', {
        token: this.token
      }).then((response) => {
        store.state.showing.preloader = false
        this.preg_students = response.data
      }, (error) => {
        this.error_text = error.data
      })
    },
    pregStudentsToExam: async function() {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/vizsgak/vizsga_add_prereg_course', {
        token: this.token
      }).then((response) => {
        store.state.showing.preloader = false
        console.log(response.data);
        this.prereg_response = response.data
        this.pregStudents()
      }, (error) => {
        this.error_text = error.data
      })
    },
    delPregStudent: async function(eab_id) {
    if (confirm("Biztosan törli az előjegyzést?")) {
      store.state.showing.preloader = true
      await this.gettoken()
      this.$http.post('/vizsgak/del_prereg_student_20210720', {
        token: this.token,
        eab_id: eab_id
      }).then((response) => {
        this.delete_result = response.data
        this.deleteexam_snackbar = true
        store.state.showing.preloader = false
        this.pregStudents()
      }, (error) => {
        this.error_text = error.data
      })
     }
    },
    getOktatok: async function() {
      await this.gettoken()
      this.$http.post('/oktatok/teacher_list_active', {
        token: this.token
      }).then((response) => {
        this.csiga_oktatok = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    getTanulok: async function() {
      this.students_table_loader = true;
      this.students = []
      await this.gettoken()
      this.$http.post('/vizsgak/vizsga_search_students_230914', {
        token: this.token,
        selected_oktato: this.selected_oktato
      }).then((response) => {
        this.students_table_loader = false;
        this.students = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    getTanulokElm: async function() {
      this.students_table_loader = true;
      this.elm_students = []
      await this.gettoken()
      this.$http.post('/vizsgak/vizsga_search_students_elm', {
        token: this.token,
        nev: this.elm_student_search
      }).then((response) => {
        this.students_table_loader = false;
        this.elm_students = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    getExamType: async function(contract_id, customer_id, course_student_id, birthdate) {
      this.getExamTypeLoader = true;
      this.exam_types = [];
      await this.gettoken()
      this.$http.post('/kokeny/exam_get_type', {
        token: this.token,
        SzakoktatoId: this.selected_oktato,
        contract_id: contract_id,
        customer_id: customer_id,
        course_student_id: course_student_id,
        birthdate: birthdate
      }).then((response) => {
        this.getExamTypeLoader = false;
        if (response.data['success'] == false) {
          this.exam_type_load_text = response.data['message'];
          this.exam_select_error_dialog = true;
          this.delete_result = response.data['message'];
          this.exam_types = [];
        } else {
          this.exam_types = response.data['vizsgak'];  
        }
        console.log(response.data);
      }, (error) => {
        this.error_text = error.data
      })
    },
    getElmExamType: async function(contract_id, customer_id, course_student_id, birthdate) {
      this.getElmExamTypeLoader = true;
      this.elm_exam_types = [];
      await this.gettoken()
      this.$http.post('/kokeny/exam_get_type_elm_230929', {
        token: this.token,
        contract_id: contract_id,
        customer_id: customer_id,
        course_student_id: course_student_id,
        birthdate: birthdate,
        exam_type_code: this.selected_exam_type_code
      }).then((response) => {
        this.getElmExamTypeLoader = false;
        if (response.data['success'] == false) {
          //this.exam_type_load_text = response.data['message'];
          this.elm_exam_select_error_dialog = true;
          this.delete_result = response.data['message'];
          this.elm_exam_types = [];
        } else {
          this.elm_exam_types = response.data['vizsgak'];  
        }
        console.log(response.data);
      }, (error) => {
        this.error_text = error.data
      })
    },
     removeSelectedStudents(item) {
      if (!item.exam_type || item.exam_type == '' || (!item.frsz || item.frsz == '' && item.soap_course_type_code != 'AM') || !item.exam_invoice || item.exam_invoice == '') {
          const index = this.selected_students.indexOf(item);
          this.selected_students.splice(index, 1)
      }
    },
    removeSelectedStudentsElm(item) {
      if (!item.exam_type || item.exam_type == '' || !item.exam_invoice || item.exam_invoice == '') {
          const index = this.selected_students_elm.indexOf(item);
          this.selected_students_elm.splice(index, 1)
      }
    },
    gyakStudFrszValidator(item) {
      if ((!item.frsz || item.frsz == '') && item.soap_course_type_code != 'AM') {
        this.valid_frsz = false;
      } else {
        this.valid_frsz = true;
      }

      if (/([A-Z][A-Z][A-Z][A-Z0-9][A-Z0-9][A-Z0-9][A-Z0-9]?)/.test(item.frsz['Megnevezes']) || /([A-Z][A-Z][A-Z][A-Z0-9][A-Z0-9][A-Z0-9][A-Z0-9]?)/.test(item.frsz) || item.soap_course_type_code == 'AM') {
        this.valid_frsz = true;
      } else {
        this.valid_frsz = false;
        alert("Hibás rendszám formátum! (csak nagybetű és szám, kötőjel nélkül)");
      }
    },
    gyakStudPaymentValidator(item) {
      if (this.admin) {
        this.valid_payment = true;
      } else {
        if (!item.exam_invoice || item.exam_invoice == '') {
          this.valid_payment = false;
        }

        if (item.exam_invoice[0]['amount']) {
          this.valid_payment = true;
        } else {
          this.valid_payment = false;
          alert("A vizsgadíj összege csak a listából választható!");
        }
      }
    },
    gyakStudExamValidator(item) {
      if (!item.exam_type || item.exam_type == '') {
        this.exam_type_valid = false;
      }

      if (item.exam_type[0]['Kod']) {
        this.exam_type_valid = true;
      } else {
        this.exam_type_valid = false;
        alert("A vizsga típusa csak a listából választható!");
      }
    },
    elmStudPaymentValidator(item) {
      if (this.admin) {
        this.valid_payment_elm = true;
      } else {
        if (!item.exam_invoice || item.exam_invoice == '') {
        this.valid_payment_elm = false;
      }

      if (item.exam_invoice[0]['amount']) {
        this.valid_payment_elm = true;
      } else {
        this.valid_payment_elm = false;
        alert("A vizsgadíj összege csak a listából választható!");
      }
      }
    },
    elmStudExamValidator(item) {
      if (!item.exam_type || item.exam_type == '') {
        this.exam_type_valid_elm = false;
      }

      if (item.exam_type[0]['Kod']) {
        this.exam_type_valid_elm = true;
      } else {
        this.exam_type_valid_elm = false;
        alert("A vizsga típusa csak a listából választható!");
      }
    },
    getPayments: async function(contract_id, customer_id) {
      this.getElmExamTypeLoader = true;
      this.exam_fees = [];
      await this.gettoken()
      this.$http.post('/vizsgak/vizsga_search_students_vd', {
        token: this.token,
        contract_id: contract_id,
        customer_id: customer_id,
      }).then((response) => {
        this.getElmExamTypeLoader = false;
        this.exam_fees = response.data;
        //console.log(response.data);
      }, (error) => {
        this.error_text = error.data
      })
    },
    getRendszam: async function(contract_id, customer_id, course_student_id, birthdate) {
      this.getExamTypeLoader = true;
      this.rendszamok = [];
      await this.gettoken()
      this.$http.post('/kokeny/exam_get_frsz', {
        token: this.token,
        SzakoktatoId: this.selected_oktato,
        contract_id: contract_id,
        customer_id: customer_id,
        course_student_id: course_student_id,
        birthdate: birthdate
      }).then((response) => {
        this.getExamTypeLoader = false;
        if (response.data['success'] == false) {
          this.frsz_load_text = response.data['message'];
          //this.deleteexam_snackbar = true;
          this.delete_result = response.data['message'];
          this.rendszamok = [];
        } else {
          this.rendszamok = response.data;  
        }
        console.log(response.data);
      }, (error) => {
        this.error_text = error.data
      })
    },
    searchVizsgaidopont: async function() {
      this.exam_search_table_loader = true;
      this.exam_search_students = []
      await this.gettoken()
      this.$http.post('/kokeny/exam_dates_231113', {
        token: this.token,
        nev_search: this.nev_search,
        studId_search: this.studId_search,
        search_exam_picked: this.search_exam_picked,
        gyak_vizsgahely_search: this.gyak_vizsgahely_search,
        oktato_search: this.oktato_search
      }).then((response) => {
        this.exam_search_table_loader = false;
        console.log(response.data);
        this.exam_search_students = response.data;
      }, (error) => {
        this.exam_search_table_loader = false;
        this.error_text = error.data
      })
    },
    sendVizsgaidopont: async function() {
      this.mail_loader = true;
      await this.gettoken()
      this.$http.post('/kokeny/kresz_message_231030', {
        token: this.token,
        students_to_mail: this.students_to_mail,
        message_text: this.message_text
      }).then((response) => {
        this.mail_loader = false;
        this.delete_result = response.data;
        this.deleteexam_snackbar = true;
        console.log(response.data);
      }, (error) => {
        this.mail_loader = false;
        this.error_text = error.data
      })
    },
    sendVizsgaidopontToTeacher: async function() {
      this.mail_loader = true;
      await this.gettoken()
      this.$http.post('/kokeny/oktato_message', {
        token: this.token,
        students_to_mail: this.students_to_mail,
        message_text: this.message_text,
        oktato: this.oktato_search
      }).then((response) => {
        this.mail_loader = false;
        this.delete_result = response.data;
        this.deleteexam_snackbar = true;
        console.log(response.data);
      }, (error) => {
        this.mail_loader = false;
        this.error_text = error.data
      })
    },
    sendVizsgaidopontAfterSave: async function() {
      this.sendAfterSave_loader = true;
      await this.gettoken()
      this.$http.post('/kokeny/gyak_message', {
        token: this.token,
        students_to_mail: this.saved_exam_results,
        oktato_checkbox: this.oktato_checkbox,
        tanulo_checkbox: this.tanulo_checkbox,
        selected_oktato: this.selected_oktato
      }).then((response) => {
        this.sendAfterSave_loader = false;
        this.delete_result = response.data;
        this.deleteexam_snackbar = true;
        this.oktato_checkbox = false;
        this.tanulo_checkbox = false;
        console.log(response.data);
      }, (error) => {
        this.sendAfterSave_loader = false;
        this.error_text = error.data
      })
    },
    getVizsgahelyek: async function() {
      this.postData = []
      await this.gettoken()
      this.$http.post('/kokeny/gyak_vizsgahely', {
        token: this.token
      }).then((response) => {
        console.log(response.data);
        this.gyak_vizsgahely = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    getElmVizsgahelyek: async function() {
      this.postData = []
      await this.gettoken()
      this.$http.post('/kokeny/elm_vizsgahely', {
        token: this.token
      }).then((response) => {
        this.elm_exam_places = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    getVizsgaIdopontok: async function() {
      this.gyak_exam_table_loader = true;
      this.gyak_idopontok = []
      await this.gettoken()
      this.$http.post('/kokeny/exam_gyak_idopontok', {
        token: this.token,
        selected_students: this.selected_students,
        gyak_start_date: this.gyak_start_date,
        gyak_end_date: this.gyak_end_date,
        selected_gyak_vizsgahely: this.selected_gyak_vizsgahely,
      }).then((response) => {
        this.gyak_exam_table_loader = false;
        if (!response.data) {
          this.gyak_idopontok = [];  
        } else {
          this.gyak_idopontok = response.data;  
        }
      }, (error) => {
        this.error_text = error.data
      })
    },
    getElmVizsgaIdopontok: async function() {
      this.elm_exam_table_loader = true;
      this.elm_idopontok = []
      await this.gettoken()
      this.$http.post('/kokeny/exam_elm_idopontok_231221', {
        token: this.token,
        selected_students: this.selected_students_elm,
        elm_start_date: this.elm_start_date,
        elm_end_date: this.elm_end_date,
        exam_type_code: this.selected_exam_type_code,
        elm_exam_place: this.elm_exam_place
      }).then((response) => {
        this.elm_exam_table_loader = false;
        if (!response.data) {
          this.elm_idopontok = [];  
        } else {
          this.elm_idopontok = response.data;  
        }
      }, (error) => {
        this.error_text = error.data
      })
    },
    gyakExamDeadlineCheck() {
      let str_date = this.selected_gyak_exam[0]['Idopont'];
      console.log(str_date);
      //let str_date = "2023-09-29 11:00";
      let deadline_date = new Date(str_date);
      deadline_date.setDate(deadline_date.getDate() - 8);
      let today = new Date();
      if (today > deadline_date) {
        this.gyak_deadline_check_dialog = true;
      } else {
        this.addGyakVizsga();
      }
    },
    addGyakVizsga: async function() {
      this.saved_exam_results = [];
      this.gyak_vizsga_rogzit_loader = true;
      await this.gettoken()
      this.$http.post('/kokeny/exam_gyak_add_250130', {
        token: this.token,
        selected_students: this.selected_students,
        gyak_start_date: this.gyak_start_date,
        gyak_end_date: this.gyak_end_date,
        selected_gyak_vizsgahely: this.selected_gyak_vizsgahely,
        selected_gyak_exam: this.selected_gyak_exam,
        admin: this.admin
      }).then((response) => {
        this.gyak_vizsga_rogzit_loader = false;
        if (response.data['success'] == true) {
          this.gyak_success_color = "blue";
          this.gyak_save_success = 'true';
          this.gyak_save_title = 'Sikeres rögzítés';
          this.gyak_save_vizsgahely = response.data['adatok']['HelyszinCim'];
          this.gyak_save_students = response.data['adatok']['JelentkezettUgyek'];
          this.saved_exam_results = response.data['adatok'];
          this.gyak_save_error = response.data['adatok']['HibaUzenetek'];
          this.gyak_exam_result_dialog = true;
          this.selected_students = [];
          this.gyak_idopontok = [];
        } else {
          this.gyak_success_color = "red";
          this.gyak_save_success = 'false';
          this.gyak_save_title = 'Hiba történt a rögzítés során!';
          this.gyak_save_error = response.data['message']
          this.gyak_exam_result_dialog = true;
        }
      }, (error) => {
        this.gyak_vizsga_rogzit_loader = false;
        this.error_text = error.data
      })
    },
    elmExamDeadlineCheck() {
      let str_date = this.selected_elm_exam[0]['Idopont'];
      console.log(str_date);
      //let str_date = "2023-09-29 11:00";
      let deadline_date = new Date(str_date);
      deadline_date.setDate(deadline_date.getDate() - 8);
      let today = new Date();
      if (today > deadline_date) {
        this.elm_deadline_check_dialog = true;
      } else {
        this.addElmVizsga();
      }
    },
    addElmVizsga: async function() {
      this.saved_exam_results = [];
      this.elm_vizsga_rogzit_loader = true;
      await this.gettoken()
      this.$http.post('/kokeny/exam_elm_add_230926', {
        token: this.token,
        selected_students: this.selected_students_elm,
        selected_elm_exam: this.selected_elm_exam,
        admin: this.admin
      }).then((response) => {
        this.elm_vizsga_rogzit_loader = false;
        if (response.data['success'] == true) {
          this.elm_success_color = "blue";
          this.elm_save_success = 'true';
          this.elm_save_title = 'Sikeres rögzítés';
          this.elm_save_vizsgahely = response.data['adatok']['HelyszinCim'];
          this.elm_save_students = response.data['adatok']['JelentkezettUgyek'];
          this.saved_exam_results = response.data['adatok'];
          this.elm_save_error = response.data['adatok']['HibaUzenetek'];
          this.elm_exam_result_dialog = true;
          this.selected_students_elm = [];
          this.elm_idopontok = [];
        } else {
          this.elm_success_color = "red";
          this.elm_save_success = 'false';
          this.elm_save_title = 'Hiba történt a rögzítés során!';
          this.elm_save_error = response.data['message']
          this.elm_exam_result_dialog = true;
        }
      }, (error) => {
        this.error_text = error.data
      })
    },
    getOktatok01: async function() {
      await this.gettoken()
      this.$http.post('/kokeny/oktatok_01', {
        token: this.token
      }).then((response) => {
        this.csiga1_oktatok = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    checkMotorosMelle: async function() {
      this.motorosCheckLoader = true;
      this.motorosMelle_check_idopont = '';
      this.motorosMelle_check_helyszin = '';
      this.motorosMelle_check_kategoria = '';
      this.motorosMelle_check_targy = '';
      this.motorosMelle_check_error = '';
      await this.gettoken()
      this.$http.post('/kokeny/exam_gyak_add_motoros_preview', {
        token: this.token,
        selected_students: this.selected_students,
        karton_azonosito: this.karton_azonosito
      }).then((response) => {
        this.motorosCheckLoader = false;
        this.motorosMelle_check_dialog = true;
        if (response.data['result'] == 'success') {
            this.motorosMellePost = response.data['postdata'];
            this.motorosMelle_check_idopont = response.data['adatok'][0];
            this.motorosMelle_check_helyszin = response.data['adatok'][1];
            this.motorosMelle_check_kategoria = response.data['adatok'][2];
            this.motorosMelle_check_targy = response.data['adatok'][3];
        }
        if (response.data['result'] == 'error') {
            this.motorosMelle_check_error = response.data['message'];
        }
        console.log(response.data);
      }, (error) => {
        this.motorosCheckLoader = false;
        this.error_text = error.data
      })
    },
    addMotorosMelle: async function() {
      this.saved_exam_results = [];
      this.motorosSaveLoader = true;
      await this.gettoken()
      this.$http.post('/kokeny/exam_gyak_add_motoros', {
        token: this.token,
        selected_students: this.selected_students,
        motorosMellePost: this.motorosMellePost,
        karton_azonosito: this.karton_azonosito,
        admin: this.admin
      }).then((response) => {
        this.motorosSaveLoader = false;
        this.motorosMelle_check_dialog = false;
        if (response.data['success'] == true) {
          this.gyak_success_color = "blue";
          this.gyak_save_success = 'true';
          this.gyak_save_title = 'Sikeres rögzítés';
          this.gyak_save_vizsgahely = response.data['adatok']['HelyszinNev'];
          this.gyak_save_students = response.data['adatok']['JelentkezettUgyek'];
          this.saved_exam_results = response.data['adatok'];
          this.gyak_save_error = response.data['adatok']['HibaUzenetek'];
          this.motorosMelle_result_dialog = true;
          this.selected_students = [];
          this.gyak_idopontok = [];
        } else {
          this.gyak_success_color = "red";
          this.gyak_save_success = 'false';
          this.gyak_save_title = 'Hiba történt a rögzítés során!';
          this.gyak_save_error = response.data['message']
          this.motorosMelle_result_dialog = true;
        }
      }, (error) => {
        this.motorosSaveLoader = false;
        this.error_text = error.data
      })
    },
    getOktatok02: async function() {
      await this.gettoken()
      this.$http.post('/kokeny/oktatok_02', {
        token: this.token
      }).then((response) => {
        this.csiga2_oktatok = response.data;
      }, (error) => {
        this.error_text = error.data
      })
    },
    userState: function() {
      var user = firebase.auth().currentUser;
      if (user) {
        this.user = user.phoneNumber;
      } else {
        this.user = "No user signed in";
        this.error_text = "Bejelentkezés szükséges!"
      }
    },
    fetchExamsDetails(exam_id, id) {
      this.exam_id = exam_id
      this.new_exam_id = id
      this.VizsgaDetails_show = true
      this.Vizsgak_show = false
    },
    goToStudent(contract_id, customer_id) {
        this.Diakok_show = false
        this.DiakokDetails_show = true
        this.contract_id = null
        this.customer_id = null
        this.contract_date = null
        this.contract_id = contract_id
        this.customer_id = customer_id
        router.push({ path: 'diakok' })
    },
    ExamSearch: function() {

    }
  },
  watch: {
    picked: function() {
      this.search = ''
      this.fetchExams()
    },
    Vizsgak_show: function(value) {
      if (value == true) {
        this.fetchExams()
      }
    },
    selected_oktato: function() {
      this.selected_students = [];
      this.gyak_start_date = date.toISOString().substr(0, 10);
      this.gyak_end_date = end_date.toISOString().substr(0, 10);
      this.selected_gyak_vizsgahely = null;
      this.selected_gyak_exam = null;
      this.getTanulok()
    },
    exam_students_tab: function(value) {
      if (value == 1) {
        //this.getVizsgahelyek()
      }
    },
    selected_students: function() {
      this.gyak_idopontok = [];
      this.selected_gyak_exam = [];
    },
    selected_students_elm: function() {
      this.elm_idopontok = [];
      this.selected_elm_exam = [];
    },
    search_exam_picked: function() {
      this.students_to_mail = [];
      this.exam_search_students = [];
      this.gyak_vizsgahely_search = '';
      this.oktato_search = '';
      //this.searchVizsgaidopont();
    },
    user_mail: function(value) {
      if (value == 'vizsga@csigaver.hu') {
        this.exam_tab = 1;
      }
    },
    oktato_search: function() {
      this.students_to_mail = [];
      this.exam_search_students = [];
    },
  },
  async mounted() {
    store.state.showing.preloader = true
    await this.gettoken()
    this.userState()
    this.fetchExams()
    this.getOktatok()
    this.getVizsgahelyek()
    this.getElmVizsgahelyek()
    if (this.user_mail == 'vizsga@csigaver.hu') {
        this.exam_tab = 1;
        this.search_exam_picked = 'Gyakorlat';
      }
    //this.getOktatok01()
    //this.getOktatok02()
  },

  created() {
    this.$eventBus.$on('deleteresult', (data) => {
    this.delete_result = data
    this.deleteexam_snackbar = true
    });
    this.$eventBus.$on('prereg', () => {
          this.pregStudentsToExam();
    })
  },

  updated() {

  },
  computed: {
    studentAmountCheck() {
      if (this.selected_students.length == 1) {
        return true;
      } else {
        return false;
      }
    },
    ...mapFields([
      'auth.admin',
      'auth.user_mail',
      'showing.Vizsgak_show',
      'showing.VizsgaDetails_show',
      'showing.preloader',
      'exam_details.exam_id',
      'exam_details.new_exam_id',
      'diakok_details.contract_id',
      'diakok_details.customer_id',
    ]),
  },
}

</script>

<style>
</style>
